import { DashboardLayout } from "../Dashboard/DashboardLayout"
import { MockExams } from "./MockExamTable"


const MockTestView = () => {
  return (
    <DashboardLayout>
      <div className="flex flex-col gap-20 w-full">
        <h1 className="text-xl font-bold mx-4 my-8 text-center text-primary">Practice Test for DWO</h1>
        <div>
        <h1 className="text-xl font-bold text-center w-[80%] mx-auto my-6 text-red-500">This is <b>NOT</b> the <b>Actual Exam</b></h1>
          <h1 className="text-xl text-center text-red-500 font-bold w-[80%] mx-auto my-6">Practice Test is for Practice Purpose only</h1>
          <h1 className="text-xl text-center text-red-500 font-bold w-[80%] mx-auto my-6">Practice Test is also only Desktop or Laptop Compatible</h1>
          <h1 className="text-lg text-center text-red-500 font-semibold w-[80%] mx-auto">The time allocated and the Questions in this <b>Practice Test</b> differs from the <b>Actual Exam</b>. The purpose of this Practice Test is to help you become familiar with the exam environment and procedures</h1>
        </div>
        <MockExams/>
      </div>
    </DashboardLayout>
  )
}

export default MockTestView